import { SelectedRoleEnum } from '@/store/types'
import { Modal } from '@seiue/ui'
import { createEnumHelper } from '@seiue/util'

import { UserDetailModal } from '../pages/UserDetailModal'

/**
 * 打开用户个人详情
 *
 * @param rid - 用户 ID
 * @param role - 用户角色
 * @param afterClose - 关闭后的回调
 */
export const openUserDetail = (
  rid: number,
  role: string,
  afterClose?: () => void
) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <UserDetailModal
        onClose={() => {
          hide()
          afterClose?.()
        }}
        rid={rid}
        role={role}
      />
    ),
  })
}

export const selectedRoleToLabel = createEnumHelper(() => ({
  [SelectedRoleEnum.Mentor]: '导师',
  [SelectedRoleEnum.Dean]: '学院',
  [SelectedRoleEnum.EducationalSupervisor]: '书院',
  [SelectedRoleEnum.AcademicAffairs]: '教务',
  [SelectedRoleEnum.SchoolLeaders]: '全校',
  [SelectedRoleEnum.Yuke]: '预科部',
  [SelectedRoleEnum.AdminclassMentor]: '行政班',
}))
